// Libs
import classNames from 'classnames/bind';
import { Box, Grid2, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
import { BaseLabel } from '~/components/common';
// Others
import { EMPTY_VALUE } from '~/utils/constants/common';
import { formatPhoneNumber } from '~/utils/helper/common';
import { useAppSelector } from '~/utils/redux/hooks';
// Styles, images, icons
import styles from './BasicInformation.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const BasicInformation = (props: Props) => {
  //#region Destructuring Props
  const {} = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/vendors', 'common/base']);
  const { detailVendor } = useAppSelector((state) => state.vendor);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const renderValueItem = (label: string, value: string) => {
    return (
      <Stack gap={1}>
        <Typography className={cx('label')}>{label}</Typography>
        <Typography className={cx('value')}>{value}</Typography>
      </Stack>
    );
  };
  //#endregion Handle Function

  return (
    <Box id='basicInformationComponent' className={cx('container')}>
      <BaseLabel styleType='title' label={t('vendor_detail_basic_information_title')} />

      <Grid2 container rowSpacing={4} columnSpacing={2}>
        <Grid2 size={6}>
          <Stack gap={'17px'}>
            {renderValueItem(t('vendor_detail_contact_name_label'), detailVendor?.contactName || EMPTY_VALUE)}

            {renderValueItem(t('vendor_detail_address_label'), detailVendor?.address || EMPTY_VALUE)}
          </Stack>
        </Grid2>

        <Grid2 size={6}>
          <Stack gap={'17px'}>
            {renderValueItem(t('vendor_detail_email_label'), detailVendor?.email || EMPTY_VALUE)}

            {renderValueItem(
              t('vendor_detail_phone_label'),
              detailVendor?.phoneNumber ? formatPhoneNumber(detailVendor.phoneNumber) : EMPTY_VALUE
            )}
          </Stack>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default BasicInformation;
